import { BannerId } from '../../typings/banners';

export const UPDATE_TURBO_GALLERY = 'UPDATE_TURBO_GALLERY';
export type UPDATE_TURBO_GALLERY = typeof UPDATE_TURBO_GALLERY;

export interface UpdateTurboGallery {
    type: UPDATE_TURBO_GALLERY;
    bannerId: BannerId;
    turboGalleryHref: string;
}

export function updateTurboGallery(
    bannerId: BannerId,
    turboGalleryHref: string
): UpdateTurboGallery {
    return {
        type: UPDATE_TURBO_GALLERY,
        bannerId,
        turboGalleryHref
    };
}

export type BannerTurboGalleryActions = UpdateTurboGallery;
